<template>
  <div ref="areaPanel" class="area"></div>
</template>
<script>
import * as echarts from "echarts";
import { debounce } from "lodash";
export default {
  name: "HistogramPanel",
  props: {
    xAxisData: {
      type: Array,
      required: true,
    },
    seriesData: {
      type: Array,
      required: true,
    },
    legendData: {
      type: Array,
      required: true,
    },
  },
  watch: {
    xAxisData: {
      immediate: true,
      handler(newVal) {
        this.option.xAxis.data = newVal;
        this.chartInstance?.setOption(this.option);
      },
    },
    seriesData: {
      immediate: true,
      handler(newVal) {
        for (let i = 0; i < newVal.length; i++) {
          const element = newVal[i];
          this.option.series[i].data = element;
        }
        this.chartInstance?.setOption(this.option);
      },
    },
    legendData: {
      immediate: true,
      handler(newVal) {
        this.option.legend.data = newVal;
        for (let i = 0; i < newVal.length; i++) {
          const element = newVal[i];
          this.option.series[i].name = element;
        }
        this.chartInstance?.setOption(this.option);
      },
    },
    // 监听 option 变化并更新图表
    option: {
      handler(newOption) {
        this.chartInstance?.setOption(newOption);
      },
      deep: true,
    },
  },
  data() {
    return {
      myChart: null,
      chartInstance: null,
      option: {
        color: ["#80FFA5", "#FDA200"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: this.legendData,
          textStyle: {
            color: "#ffffff",
          },
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xAxisData,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "全部订单",
            type: "line",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#80FFA5",
                },
                {
                  offset: 1,
                  color: "#01BFEC",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
          },
          {
            name: "过海订单",
            type: "line",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#FDA200",
                },
                {
                  offset: 1,
                  color: "#775500",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
          },
          {
            name: "订单",
            type: "line",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#3183d7",
                },
                {
                  offset: 1,
                  color: "#5b95b2",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
    this.chartInstance?.dispose();
  },
  methods: {
    initChart() {
      if (!this.$refs.areaPanel) return;
      this.chartInstance = echarts.init(this.$refs.areaPanel);
      this.chartInstance.setOption(this.option);
      this.$emit("ready");
    },
    resizeChart: debounce(function () {
      this.chartInstance?.resize();
    }, 200),
  },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>